import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import Helmet from 'react-helmet';
import InfoIcon from 'dibs-vg/dist/react/info-circle';

// styles
import styles from './PdpSharedAffirm.scss';

// helpers
import get from 'lodash.get';
import { showAffirm, affirmSnippet } from '../helpers/affirm';

export function PdpSharedAffirmComponent({ currency, viewer, user, item }) {
    if (!showAffirm({ viewer, item, user, currency })) {
        return null;
    }

    // amount in cents
    const amount = get(item, 'pricing.totalAmount.convertedAmounts.USD') * 100;

    return (
        <div className={styles.affirm}>
            <Helmet script={[{ innerHTML: affirmSnippet }]} />
            <span
                className="affirm-as-low-as"
                data-promo-id="promo_set_default"
                data-affirm-color="black"
                data-learnmore-show="false"
                data-amount={amount}
            />
            <a
                className={`${styles.affirmInfo} affirm-product-modal`}
                data-promo-id="promo_set_default"
                data-amount={amount}
            >
                <InfoIcon />
            </a>
        </div>
    );
}

PdpSharedAffirmComponent.propTypes = {
    currency: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
};

export const PdpSharedAffirm = createFragmentContainer(PdpSharedAffirmComponent, {
    viewer: graphql`
        fragment PdpSharedAffirm_viewer on Viewer {
            affirmEnabled: isEnabledByLocale(featureName: "AFFIRM")
            regionalInfo {
                countryCode
            }
        }
    `,
    user: graphql`
        fragment PdpSharedAffirm_user on User {
            isVerifiedTrade
        }
    `,
    item: graphql`
        fragment PdpSharedAffirm_item on Item {
            affirmDisplayInfo: displayInfo {
                showAffirmPromo
            }
            pdpTypeDisplay
            pricing {
                totalAmount {
                    convertedAmounts {
                        USD
                    }
                }
            }
        }
    `,
});
